import { HrefProp, Types } from '@scorenco/core';

import { PageSeo } from './PageSeo';

type StrapiPageSeoProps = {
  seo: Pick<Types.ComponentSharedSeo, 'metaTitle' | 'metaDescription'> & {
    metaImage?: { url?: string | null } | null;
  };
  url: HrefProp;
};

export const StrapiPageSeo = ({ seo, url }: StrapiPageSeoProps) => {
  return (
    <PageSeo
      title={seo.metaTitle as string}
      description={seo.metaDescription as string}
      sharedImage={seo.metaImage?.url ?? undefined}
      url={url}
    />
  );
};
